export const MILIMETERS_TO_INCHES = 0.03937;
